import type { GameType, UserTier } from './protocol.js';

export interface RoomHistoryLink {
  id: string;
  key: string;
  roomId: string;
  startedAt: string;
}

export interface GameHistoryPlayer {
  playerId: string;
  name: string;
  isBot: boolean;
  userId?: string | null;
}

export interface PlayerMatchSummary {
  id: string;
  roomId: string;
  gameType: GameType;
  finishedAt: string;
  won: boolean;
  scoreDelta?: number;
  playerCount: number;
}

export interface PublicPlayerProfile {
  id: string;
  displayName: string;
  tier: UserTier;
  level: number;
  xp: number;
  wins: number;
  gamesPlayed: number;
  winRate: number;
  recentMatches: PlayerMatchSummary[];
  isFriend?: boolean;
  isPending?: boolean;
}

export interface RoomGameResult {
  id: string;
  gameType: GameType;
  startedAt: string;
  finishedAt: string;
  winnerId: string;
  players: GameHistoryPlayer[];
}

export interface RoomSessionHistory {
  id: string;
  roomId: string;
  startedAt: string;
  endedAt: string | null;
  games: RoomGameResult[];
}

export function roomWinTotals(history: RoomSessionHistory) {
  const players = new Map<string, GameHistoryPlayer & { played: number; big2: number; muushig: number; twentyone: number; daaluu: number }>();
  for (const game of history.games) {
    for (const player of game.players) {
      const total = players.get(player.playerId) ?? { ...player, played: 0, big2: 0, muushig: 0, twentyone: 0, daaluu: 0 };
      total.played++;
      if (player.playerId === game.winnerId) {
        if (total[game.gameType] !== undefined) {
          total[game.gameType]++;
        }
      }
      players.set(player.playerId, total);
    }
  }
  return [...players.values()].sort((left, right) =>
    (right.big2 + right.muushig + right.twentyone + right.daaluu) - (left.big2 + left.muushig + left.twentyone + left.daaluu) ||
    left.name.localeCompare(right.name)
  );
}
